module.exports = __webpack_public_path__ + "static/media/1.bc0c7b9d.jpg";